$(document).ready(function () {

  $('.partials-index').scroll((e) => {
    if ($(e.target).find('.hero').offset().top < -20) {
      $('.header.hide-on-scroll').fadeOut(500)
    }else {
      $('.header.hide-on-scroll').fadeIn(500)
    }
  })


})
